import { types } from "../Actions/types";
// import { cloneDeep, merge } from "lodash";


const initialState = {
    userInsights: {}
};

const UserInsights = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.USER_INSIGHTS:
            return {
                ...state,
               userInsights: payload,
            };

        default:
            return state;
    }
};

export default UserInsights;
